import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const BannerSignIn = styled.div`
  background: ${colors.white};
  position: fixed;
  width: 100%;
  z-index: 4;
  left: 0;
  top: 0;
  padding-top: 66px;
  display: ${props => (props.isOpenSigninBox ? 'block' : 'none')};

  @media (min-width: 768px) {
    width: auto;
    position: relative;
    display: block;
    padding-top: 0;
  }

  @media (min-width: 992px) {
    width: 395px;

    &.language-canada {
      top: -100px;
    }
  }
`;
